//调查问卷
const settingBox = () => import('@/components/setting/settingBox');
const roulette = () => import('@/components/setting/roulette');

export default {
    path: '/settingBox',
    name: 'settingBox',
    component: settingBox,
    children: [
        { path: 'roulette', component: roulette, name: 'roulette' },
    ]
}



// WEBPACK FOOTER //
// ./src/router/routes/setting.js